import type { Cable as CableType } from '@anycable/core'
import { createCable } from '@anycable/web'
import React, { createContext, useContext, useEffect, useState } from 'react'

import { getAuthToken } from '~/App/utils/api/authToken'
import { CABLE_URL } from '~/constants/environment'

type ContextState =
  | {
      loaded: true
      cable: CableType
    }
  | {
      loaded: false
      cable: undefined
    }

const StoreContext = createContext<ContextState | undefined>(undefined)

function CableProvider({ children }: React.PropsWithChildren) {
  const [cable, setCable] = useState<CableType>()

  useEffect(() => {
    const token = getAuthToken()
    if (!token) {
      throw new Error('Cable intialized before Auth')
    }
    const c = createCable(CABLE_URL, {
      pingInterval: 10000,
      // @ts-expect-error anycable is expecting subprotocol to be a string and not a string[]
      subprotocol: ['actioncable-v1-json', token],
    })

    setCable(c)

    return () => {
      c?.disconnect()
      setCable(undefined)
    }
  }, [])

  return (
    <StoreContext.Provider
      value={
        cable
          ? {
              loaded: true,
              cable,
            }
          : {
              loaded: false,
              cable: undefined,
            }
      }
    >
      {children}
    </StoreContext.Provider>
  )
}
const useCable = () => {
  const context = useContext(StoreContext)
  if (!context) {
    throw new Error('useCable must be used within a Cable provider')
  }
  return context
}

export { useCable }
export default CableProvider
